(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    /**
 * URL Parameters
 */
    function generateUrlParameters(type = '', features = '', environment = '') {
        var urlParameters = '';

        if (type.length > 0) {
            urlParameters += 'type=' + type;
        }

        if (features) {
            urlParameters += urlParameters ? '&' : '';
            urlParameters += 'features=' + features;
        }

        if (environment) {
            urlParameters += urlParameters ? '&' : '';
            urlParameters += 'environment=' + environment;
        }

        urlParameters = urlParameters ? '?' + urlParameters : ' ';

        if (urlParameters.length > 1) {
            history.replaceState(undefined, undefined, urlParameters);
        } else {
            history.replaceState(undefined, undefined, '?');
        }
    }

    function OEProducts(elem) {
        Behaviors.init(OEProducts, this, arguments);

        var $thisElem = this.$elem,
            loadAllActive = false;

        // Toggle Filter Groups Mobile
        $thisElem.find('.OEProducts-filters-title').on('click', function () {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');

                $(this).next().slideUp(200);
            } else {
                $(this).addClass('open');

                $(this).next().slideDown(200);
            }
        });

        // Toggle Filter Groups
        $thisElem.find('.OEProducts-filters-group h5').on('click', function () {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');

                $(this).next().slideUp(200);
            } else {
                $(this).addClass('open');

                $(this).next().slideDown(200);
            }
        });

        function addFilterTags() {
            $thisElem.find('.OEProducts-filters .OEProducts-filters-group:not(.OEProducts-filters-group-mobile) span.active').each(function () {
                $thisElem.find('.OEProducts-tag-list').append(`
                    <span class="filter-tag">` + $(this).text() + `
                        <span class="remove-filter" data-filter="` + $(this).data('filter') + `"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m9.375 6.125-3.75 3.75m0-3.75 3.75 3.75M13.75 8a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0z" stroke="#009" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                    </span>`);
            });

            // Hide/Show Clear filters button
            if ($thisElem.find('.OEProducts-tag-list').html().length > 0) {
                $thisElem.find('.OEProducts-clear-filters').show();
            } else {
                $thisElem.find('.OEProducts-clear-filters').hide();
            }
        }

        // Product Filters Ajax
        function productFilters(paged, sort = '', scroll = true, append = false, loadAll = loadAllActive) {
            var scrollOffset = $thisElem.offset().top - $('header').outerHeight() - 40,
                // loop = $thisElem.find('.OEProducts-loop'),
                loop = $thisElem.find('.OEProducts-loop-grid'),
                postType = $thisElem.data('post-type'),
                category = $thisElem.data('category') ? $thisElem.data('category') : '',
                type = '',
                features = '',
                environment = '',
                sort = $thisElem.find('.OE-Dropdown-menu span.active').length > 0 ? $thisElem.find('.OE-Dropdown-menu span.active').data('sort') : '',
                searchTag = $thisElem.find('.OEProducts-action-bar .OEProducts-search-input').val(),
                urlParameters = '',
                showDiscontinued = '';

            if ($(window).width() > 991) {
                showDiscontinued = $thisElem.find('.OEProducts-discontinued--desktop .show-discontinued-products').hasClass('active') ? 'yes' : '';
            } else {
                showDiscontinued = $thisElem.find('.OEProducts-discontinued--mobile .show-discontinued-products').hasClass('active') ? 'yes' : '';
            }

            if ($(window).width() < 992) {
                sort = $thisElem.find('.OEProducts-filters-group-list.OEProducts-mobile-sort span.active').length > 0 ? $thisElem.find('.OEProducts-filters-group-list.OEProducts-mobile-sort span.active').data('sort') : '';
            }

            if ($(window).width() < 992) {
                searchTag = $thisElem.find('.OEProducts-products-mobile_action_bar .OEProducts-search-input').val();
            }

            // Type
            $thisElem.find('.OEProducts-filters-type.active').each(function (index) {
                type += index > 0 ? ',' : '';
                type += $(this).data('filter');
            });

            // Features
            $thisElem.find('.OEProducts-filters-features.active').each(function (index) {
                features += index > 0 ? ',' : '';
                features += $(this).data('filter');
            });

            // Environment
            $thisElem.find('.OEProducts-filters-environment.active').each(function (index) {
                environment += index > 0 ? ',' : '';
                environment += $(this).data('filter');
            });

            // Url parameters
            generateUrlParameters(type, features, environment);

            $.ajax({
                url: wpAjaxUrl, // AJAX handler
                data: {
                    'action': 'products_filters_ajax',
                    paged: paged,
                    postType: postType,
                    type: type,
                    features: features,
                    environment: environment,
                    searchTag: searchTag,
                    sort: sort,
                    showDiscontinued: showDiscontinued,
                    loadAll: loadAll
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('OE--loading');
                },
                success: function (data) {
                    if (append) {
                        loop.append(data);
                    } else {
                        loop.html(data);
                    }

                    $thisElem.removeClass('OE--loading');

                    // Update products count
                    var productsCount = $thisElem.find('.OEProducts-loop-grid').data('products-count');
                    $thisElem.find('.products-count').text(productsCount);

                    $('.OEProducts-load-more-cta').data('paged', paged);
                    $('.OEProducts-load-more-cta').data('max-num-pages', parseInt($('.max-num-pages').text()));

                    $('.max-num-pages').remove();

                    if ($('.OEProducts-load-more-cta').data('paged') == $('.OEProducts-load-more-cta').data('max-num-pages')) {
                        $('.OEProducts-load-more').addClass('hide');
                    } else {
                        $('.OEProducts-load-more').removeClass('hide');
                    }

                    // Scroll to top of the products
                    if (scroll) {
                        $('html, body').animate({
                            'scrollTop': scrollOffset
                        }, 500);
                    }

                    $thisElem.find('.OEProducts-tag-list').html('');

                    // Add Filter Tags
                    addFilterTags();

                    if (loadAll) {
                        $('.OEProducts-load-more-cta--load-all').parent().addClass('hide');
                    }
                }
            });
            return false;
        }

        // Pagination
        // $(document).on("click", '.bw-pagination a', function (e) {
        //     e.preventDefault();
        //     var $this = $(this),
        //         paged = $(this).text(),
        //         current = parseInt($thisElem.find('.bw-pagination .current').text());

        //     if ($this.hasClass('prev')) {
        //         paged = parseInt(current - 1);
        //     } else if ($this.hasClass('next')) {
        //         paged = parseInt(current + 1);
        //     }

        //     productFilters(paged);
        // });

        // Load More
        $(document).on("click", '.OEProducts-load-more-cta', function (e) {
            e.preventDefault();
            var $this = $(this),
                paged = $this.data('paged'),
                maxNumPages = $this.data('max-num-pages');

            if ($this.hasClass('OEProducts-load-more-cta--load-all')) {
                loadAllActive = true;
                productFilters(paged, '', false, true);
            } else {
                if (paged <= maxNumPages) {
                    paged++;
                }
                productFilters(paged, '', false, true);
            }
        });

        // Filters
        $thisElem.find('.OEProducts-filters-group-list:not(.OEProducts-mobile-sort) span').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
                $this.addClass('active');
            }

            if ($(window).width() > 991) {
                productFilters(1);
            }
        });

        // Mobile Filters
        $thisElem.find('.OEProducts-mobile_apply').on('click', function () {
            $thisElem.find('.OEProducts-filters-title').removeClass('open');
            $thisElem.find('.OEProducts-filters-mobile-wrap').slideUp(300);

            productFilters(1);
        });

        // Remove Filters
        $(document).on('click', '.remove-filter', function (e) {
            e.preventDefault();

            var $this = $(this);

            console.log($this.data('filter'));

            $thisElem.find('.OEProducts-filters span[data-filter="' + $this.data('filter') + '"]').removeClass
                ('active');

            $this.parent().remove();

            productFilters(1);
        });

        // Clear Filters
        $thisElem.find('.OEProducts-clear-filters').on('click', function (e) {

            $thisElem.removeClass('OEProducts-mobile-open');

            $thisElem.find('.OEProducts-filters li span.active').each(function () {
                $(this).removeClass('active');
            });

            productFilters(1);
        });

        // Sorting
        $thisElem.find('.OE-Dropdown-menu span').on('click', function (e) {
            e.preventDefault();

            if ($(window).width() > 991) {

                if (!$(this).hasClass('active')) {
                    $thisElem.find('.OE-Dropdown-menu span').removeClass('active');

                    $(this).addClass('active');
                }

                productFilters(1);
            }
        });

        // Sort Mobile
        $thisElem.find('.OEProducts-filters-group-list.OEProducts-mobile-sort span').on('click', function (e) {
            e.preventDefault();
            if ($(window).width() < 992) {

                var $this = $(this);

                if (!$this.hasClass('active')) {
                    $thisElem.find('.OEProducts-filters-group-list.OEProducts-mobile-sort span').removeClass('active');
                    $this.addClass('active');
                }
            }
        });

        // Search
        $thisElem.find('.OEProducts-search').on('submit', function (e) {
            e.preventDefault();

            productFilters(1);

        });

        // Show discontinued desktop
        $thisElem.find('.OEProducts-discontinued--desktop .show-discontinued-products').on('click', function () {
            $(this).toggleClass('active');

            productFilters(1);
        });

        // Show discontinued mobile
        $thisElem.find('.OEProducts-discontinued--mobile .show-discontinued-products').on('click', function () {
            $(this).toggleClass('active');

            productFilters(1);
        });

        // Add Filter Tags
        addFilterTags();

        // Scrollbar JS
        var el = document.querySelector('.OEProducts-filters');

        if ($(window).width() > 991) {
            // SimpleScrollbar.initEl(el);
        }
    }

    Behaviors.inherit(OEProducts, Behaviors.Behavior);

    OEProducts.QUERY = "[data-oeproducts]";

    Behaviors.register_behavior(OEProducts);

    module.OEProducts = OEProducts;

    return module;

}(window.jQuery, window.Behaviors));